import { LearnerCourseDto } from '@/services/api/tenant/learnerCourses'

export type CourseSections = {
  enrolled: LearnerCourseDto[]
  completed: LearnerCourseDto[]
  inactive: LearnerCourseDto[]
}

/**
 * The three sections of the learner's assignments screen. Unavailability is read before progress,
 * so a course the learner finished before losing access lists once, under inactive.
 *
 * Enrolled lists the soonest expiry first, so the next deadline to act on leads the section. The
 * served order carries through completed and inactive: the endpoint sorts those by newest
 * completion or enrolment, then by name.
 */
export const groupCourseSections = (courses: LearnerCourseDto[]): CourseSections => {
  const sections = courses.reduce<CourseSections>(
    (grouped, course) => {
      if (course.availability === 'unavailable') {
        grouped.inactive.push(course)
      } else if (course.progress === 'completed') {
        grouped.completed.push(course)
      } else {
        grouped.enrolled.push(course)
      }
      return grouped
    },
    { enrolled: [], completed: [], inactive: [] },
  )

  sections.enrolled.sort(bySoonestExpiry)
  return sections
}

// Date-only strings, so they compare lexicographically. The sort is stable, so a shared end date
// keeps the served order.
const bySoonestExpiry = (one: LearnerCourseDto, other: LearnerCourseDto) =>
  one.cycle_end_date.localeCompare(other.cycle_end_date)
